import { NavItem, NavItemAccessor, Select } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { RecurringInvoiceFrequency } from '@features/recurringInvoices/enums/recurringInvoiceFrequency'
import { getRecurringInvoiceFrequencyLabel } from '@features/recurringInvoices/utils/getRecurringInvoiceFrequencyLabel'

import { useRecurringInvoiceForm } from '../../../../../../../../contexts/recurringInvoiceFormContext'

const frequencyDropdownListOrder: Array<RecurringInvoiceFrequency | NavItemAccessor.Separator> = [
  RecurringInvoiceFrequency.Monthly,
  RecurringInvoiceFrequency.MonthlyLastDay,
  NavItemAccessor.Separator,
  RecurringInvoiceFrequency.Weekly,
  RecurringInvoiceFrequency.Biweekly,
  NavItemAccessor.Separator,
  RecurringInvoiceFrequency.Quarterly,
  RecurringInvoiceFrequency.Semiannually,
  RecurringInvoiceFrequency.Yearly,
]

export const Frequency = () => {
  const { t } = useTranslation()
  const { recurringInvoiceForm } = useRecurringInvoiceForm()

  const { FormItem } = recurringInvoiceForm

  const items: NavItem<RecurringInvoiceFrequency>[] = useMemo(() => {
    return frequencyDropdownListOrder.map((frequency, index) => {
      if (frequency === NavItemAccessor.Separator) {
        return {
          id: `separator-${index}`,
          accessor: NavItemAccessor.Separator,
          children: '',
          value: '' as RecurringInvoiceFrequency,
        }
      }
      return {
        id: frequency,
        value: frequency,
        children: getRecurringInvoiceFrequencyLabel(frequency, t),
      }
    })
  }, [t])

  return (
    <FormItem
      name="frequency"
      label={t('external_invoices.editor.form.recurring_invoice_settings.field.frequency.label')}
      render={({ field: { onChange, value, ...props } }) => (
        <Select {...props} dropdownSize="fitTrigger" items={items} onSelect={onChange} selectedId={value} size="sm" />
      )}
    />
  )
}
